module.exports = __webpack_public_path__ + "static/media/bg.ce78e09c.jpg";